import React from "react";
import {Button, Typography} from "@mui/material";

export default function ServicesButton({ label, icon, href }) {
    return <Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href={href}>
        {icon}
        <Typography fontSize={12} position={"bottom"}>{label}</Typography>
    </Button>
}